import React from "react";
import ReactDOM from "react-dom";
import Amplify from "aws-amplify";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { PersistGate } from "redux-persist/integration/react";
import Livechat from "chatwoot";
import { persistor, store } from "redux/configureStore";

//pwa
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";

import App from "app";
import awsconfig from "aws-exports";
import * as serviceWorker from "utils/serviceWorker";
import TagManager from "react-gtm-module";
const ReactPixel = import(
  /* webpackChunkName: "ReactPixel", webpackPrefetch: true */ "react-facebook-pixel"
);
const isLocalhost = Boolean(
  window.location.hostname === "localhost" ||
    window.location.hostname === "[::1]" ||
    window.location.hostname.match(
      /^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/
    )
);
const tagManagerArgs = {
  gtmId: "GTM-PLL4MV6",
};
const [localRedirectSignIn, productionRedirectSignInLetsAdvertise] = [
  "http://localhost:3000/",
  "https://d3emvw30b7jms6.cloudfront.net/",
];

const [localRedirectSignOut, productionRedirectSignOutLetsAdvertise] = [
  "http://localhost:3000/",
  "https://d3emvw30b7jms6.cloudfront.net/",
];

TagManager.initialize(tagManagerArgs);

ReactPixel.then((rp) =>
  rp.default.init(
    450979496484873,
    {},
    {
      autoConfig: true,
      debug: false === "true",
    }
  )
);

const updatedAwsConfig = {
  ...awsconfig,
  aws_cloud_logic_custom: [...awsconfig.aws_cloud_logic_custom],
  aws_user_files_s3_bucket: "media-letsadcofinoprod-prod",
  aws_user_files_s3_bucket_region: "us-east-1",

  aws_cognito_identity_pool_id:
    "us-east-1:5b4478a6-6db4-4e8e-90a4-9665f1db7bd8",
  aws_cognito_region: "us-east-1",
  aws_user_pools_id: "us-east-1_xlithMrlJ",
  aws_user_pools_web_client_id: "65emeelcvchc43jk7nd5f7kipe",

  oauth: {
    domain: "us-east-1xlithmrlj.auth.us-east-1.amazoncognito.com",
    scope: [
      "phone",
      "email",
      "openid",
      "profile",
      "aws.cognito.signin.user.admin",
    ],
    responseType: "code",
    redirectSignIn: isLocalhost
      ? localRedirectSignIn
      : productionRedirectSignInLetsAdvertise,
    redirectSignOut: isLocalhost
      ? localRedirectSignOut
      : productionRedirectSignOutLetsAdvertise,
  },
};

Amplify.configure(updatedAwsConfig);

ReactDOM.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <BrowserRouter>
        <App awsConfig={updatedAwsConfig} />
        <Livechat />
      </BrowserRouter>
    </PersistGate>
  </Provider>,
  document.getElementById("root")
);

serviceWorker.register();

serviceWorkerRegistration.register({
  onUpdate: async (registration) => {
    if (registration && registration.waiting) {
      await registration.unregister();
      registration.waiting.postMessage({ type: "SKIP_WAITING" });
      window.location.reload();
    }
  },
});
